// @system — plan-tier helpers shared by UpgradeModal, SettingsPlanCard and BillingPage.
// Kept out of the component modules so React Fast Refresh can hot-swap them.

/**
 * Anything that may carry a plan slug: the auth user (legacy `plan` field) or a
 * user decorated with its subscription.
 * @typedef {Object} PlanCarrier
 * @property {string | null} [plan]
 * @property {{ plan?: string | null } | null} [subscription]
 */

/**
 * Normalise a plan name/slug for comparison ("Pro " → "pro").
 * @param {unknown} value
 */
export function normalizePlan(value) {
  return String(value ?? '')
    .toLowerCase()
    .trim()
}

/**
 * True when the user has no paid subscription (defaults an unknown user to free).
 * @param {PlanCarrier | null | undefined} user
 */
export function isFreeUser(user) {
  return normalizePlan(user?.subscription?.plan ?? user?.plan ?? 'free') === 'free'
}
